import Banner from '../components/Banner';
import Posts from '../pages/Posts';

export default function Home() {
 
    return (
        <>
            <Banner />
            <Posts />
        </>
    );
}
